import {AsyncInlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {SaveInstantOfferDraftFromAPISellerError} from '../Errors/SaveInstantOfferDraftFromAPISellerError.js'
import {SellerRepositoriesFactory} from '../Repositories/factory.js'
import {SaveInstantOfferDraftFromAPISellerRequest} from '../Requests/SaveInstantOfferDraftFromAPISellerRequest.js'

class SaveInstantOfferDraftFromAPISellerUseCase extends UseCase {
  #httpRepository

  constructor({httpRepository}) {
    super()
    this.#httpRepository = httpRepository
  }

  static create({config}) {
    return new SaveInstantOfferDraftFromAPISellerUseCase({
      httpRepository: SellerRepositoriesFactory.hTTPSellerRepository({config})
    })
  }

  @AsyncInlineError()
  async execute({userId, ...rawParams} = {}) {
    const request = SaveInstantOfferDraftFromAPISellerRequest.create(rawParams)

    const [error, response] = await this.#httpRepository.saveInstantOfferDraftFromAPI({
      userId,
      request
    })

    if (error) throw new SaveInstantOfferDraftFromAPISellerError(error.message)

    return response
  }
}

export const factory = SaveInstantOfferDraftFromAPISellerUseCase.create
